import Dispatcher from '../../dispatcher';
import HttpRequestConstants from '../../constants/http_request';

function tyreFilterOptionsStarted() {
    Dispatcher.handleHttpRequestAction({
        type: HttpRequestConstants.TYRE_FILTER_OPTIONS_STARTED,
    });
}

function tyreFilterOptionsSuccess() {
    Dispatcher.handleHttpRequestAction({
        type: HttpRequestConstants.TYRE_FILTER_OPTIONS_SUCCESS,
    });
}

function tyreFilterOptionsFailed() {
    Dispatcher.handleHttpRequestAction({
        type: HttpRequestConstants.TYRE_FILTER_OPTIONS_FAILED,
    });
}

function motoTyreFilterOptionsStarted() {
    Dispatcher.handleHttpRequestAction({
        type: HttpRequestConstants.MOTO_TYRE_FILTER_OPTIONS_STARTED,
    });
}

function motoTyreFilterOptionsSuccess() {
    Dispatcher.handleHttpRequestAction({
        type: HttpRequestConstants.MOTO_TYRE_FILTER_OPTIONS_SUCCESS,
    });
}

function motoTyreFilterOptionsFailed() {
    Dispatcher.handleHttpRequestAction({
        type: HttpRequestConstants.MOTO_TYRE_FILTER_OPTIONS_FAILED,
    });
}

export {
    tyreFilterOptionsStarted, tyreFilterOptionsSuccess, tyreFilterOptionsFailed,
    motoTyreFilterOptionsStarted, motoTyreFilterOptionsSuccess, motoTyreFilterOptionsFailed,
};
